import HM from "../../images/HM.png";
import Modal from "../Modules/Modal";
import { useState } from "react";

const HMmsg = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="px-md-5 bg-color-w py-md-5 p-4">
      <div className="d-flex flex-row">
        <div className="d-flex align-items-center justify-content-center pe-3">
          <img src={HM} alt="Mr. Saeed Mohammadi" style={{ width: "130px" }} />
        </div>
        <div className="d-flex align-items-center justify-content-center px-2 ">
          <h3 className="dk-bold">
            We Will Continue to Develop the E-Commerce Ecosystem in 2022
          </h3>
        </div>
      </div>

      <h5 className="my-3 dk-semi-bold">
        Hamid Mohammadi, Cofounder and Chief Executive Officer of Digikala
      </h5>
      <p className="my-3">
        Last year, was a difficult one for Iran’s economy. A year which was
        still under the shadow of COVID-19 ...
      </p>

      <h6
        className="dk-link dk-bold"
        onClick={() => {
          setShowModal(true);
        }}
      >
        {"Read More >"}
      </h6>

      <Modal showModal={showModal} setShowModal={setShowModal}>
        <div>
          <div className="d-flex flex-row">
            <div className="d-flex align-items-center justify-content-center pe-3">
              <img
                src={HM}
                alt="Mr. Saeed Mohammadi"
                style={{ width: "130px" }}
              />
            </div>
            <div className="d-flex align-items-center justify-content-center px-2 ">
              <h3 className="dk-bold">
                We Will Continue to Develop the E-Commerce Ecosystem in 2022
              </h3>
            </div>
          </div>

          <h5 className="my-3 dk-semi-bold">
            Hamid Mohammadi, Cofounder and Chief Executive Officer of Digikala
          </h5>

          <p>
            Last year, was a difficult one for Iran’s economy. A year which was
            still under the shadow of COVID-19 alongside the increased economic
            pressure. We learned a lot in 2021; COVID-19 taught us how to be
            expandable, to move towards creative methods of expandability and
            using new business models and smart decentralized solutions to have
            a much more extended presence in the country. This approach helped
            us with establishment of horizontal and vertical growth in
            collaboration with numerous business partners. In the vertical
            development, we focused on optimization and improvement of
            marketplace KPIs. Now, we are honored of being partnered with over
            250 thousand sellers and 40 million customers. Also, we could take
            big steps in digital economy by designing new business models to
            fulfil the infrastructure requirements of various e-commerce areas.
            digiexpress, SMARTECH, digipay, Pindo, diginext, increased presence
            of rural suppliers, unveiling digikalaBUSINESS, digify, digicloud
            and Magnet were all the fundamentals of developing this ecosystem as
            parts of the e-commerce value chain.
          </p>
          <p>
            In 2021-22, we stepped into a new experience of Digikala’s
            decentralized logistics network, using distributed resources in
            collaboration with logistics business partners. Thereafter, we faced
            new challenges in rapid transformation model when digikalajet and
            first DarkStores started up. Improving the experience of customers
            and sellers was our main motivation for all these steps. We are
            still committed to look at challenges and issues from the audience
            point of view. We are aware that it is impossible to eliminate all
            issues; However, we believe that they could be significantly
            minimized by novel solutions and constant effort.
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default HMmsg;
